import { render, staticRenderFns } from "./riskAssess.vue?vue&type=template&id=7045e7c6&scoped=true&"
import script from "./riskAssess.vue?vue&type=script&lang=js&"
export * from "./riskAssess.vue?vue&type=script&lang=js&"
import style0 from "./riskAssess.vue?vue&type=style&index=0&id=7045e7c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7045e7c6",
  null
  
)

export default component.exports